module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_20-f3e99dc0abb96327d4a3de830ea30919.jpg";